var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"grid-container"},[_c('Progope',{staticClass:"progope"}),_c('Appartment'),_c('Ticket',{staticClass:"ticket"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }